"use client";

import React from "react";
import { Target, Eye, Diamond } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function MissionVision() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const items = [{
    title: "Sứ Mệnh Của Chúng Tôi",
    icon: Target,
    content: "Cung cấp các giải pháp công nghệ xây dựng tiên tiến giúp các nhà thầu và chủ dự án hoàn thành công việc nhanh hơn, an toàn hơn và hiệu quả hơn."
  }, {
    title: "Tầm Nhìn Của Chúng Tôi",
    icon: Eye,
    content: "Trở thành nhà cung cấp công nghệ xây dựng hàng đầu toàn cầu, trao quyền cho các doanh nghiệp xây dựng ở mọi quy mô."
  }, {
    title: "Giá Trị Của Chúng Tôi",
    icon: Diamond,
    content: "Chúng tôi cam kết đổi mới, sự xuất sắc và trách nhiệm bền vững trong mọi công việc của mình."
  }];
  return <section id="mission-vision" ref={ref} className="bg-muted py-20 md:py-32 overflow-hidden">
      <div className={cn("container mx-auto px-6 transition-all duration-1000 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <div className="flex flex-col md:flex-row gap-8 md:gap-0 items-stretch justify-center">
          {items.map((item, index) => <React.Fragment key={index}>
              {}
              <div data-index={index} className="flex-1 flex flex-col items-center text-center px-4 md:px-8 group">
                <div className="mb-8 p-4 rounded-lg bg-background/50 shadow-sm ring-1 ring-chart-2/20 group-hover:ring-chart-2/50 transition-all duration-500">
                  <item.icon className="size-16 text-chart-2 stroke-[1.5px]" aria-hidden="true" />
                </div>
                <h3 className="text-3xl font-bold text-primary mb-6 tracking-tight">
                  {item.title}
                </h3>
                <p className="text-foreground/80 leading-relaxed text-justify text-lg">
                  {item.content}
                </p>
              </div>

              {}
              {index < items.length - 1 && <>
                  <Separator orientation="vertical" className="hidden md:block h-auto min-h-[300px] w-[1px] bg-primary/10 mx-4" />
                  <Separator orientation="horizontal" className="md:hidden w-full h-[1px] bg-primary/10 my-8" />
                </>}
            </React.Fragment>)}
        </div>
      </div>
    </section>;
}